import React, { useState } from "react";
import classnames from "classnames/bind";
import {
  addCommas,
  // addToFavoriteProperty, // from global
  // removeFromFavoriteProperty, // from global
  getCookie,
} from "../common/Common";
import { CompareButtonWithText, CompareButton } from "../Compare/Common";
import Config from "config";

const pagesLink = Config.pagesLink;

export const HeadingWrapper = React.memo((propertyDetail) => {
  return (
    <>
      <div className="heading-wrapper">
        <div className="heading-col">
          <h1>{propertyDetail.TitlePageName}</h1>
          <div className="heading-detail">
            <p>
              รหัส {propertyDetail.PropertyIDFormat}{" "}
              {propertyDetail.PropertyIDPN && (
                <span className="c-red">{` (ref: ${propertyDetail.PropertyIDPN})`}</span>
              )}
            </p>
            <span className="absolute" />
            <span
              className={classnames(["box-views", { "d-none": propertyDetail.GaCountView < 200 }])}
            >
              <i className="ic-npa ic-npa-icon-views" />
              <p>เข้าชม {addCommas(propertyDetail.GaCountView, 0)} ครั้ง</p>
            </span>
          </div>
        </div>
        <div className="heading-col">
          <div className="box-social">
            <div className="social-wrapper">
              <FavoriteToggleButton propId={propertyDetail.PropertyID} />
              <ShareBtn />
              <PrintBtn {...propertyDetail} />
            </div>
            <CompareButtonWithText {...propertyDetail} />
          </div>
        </div>
      </div>
    </>
  );
}, areEqual);

const PrintBtn = (propertyDetail) => {
  return (
    <div>
      <a
        href={pagesLink.printDetail.replace("{{PropID}}", propertyDetail.PropertyID)}
        target="_blank"
        className="social-btn"
        data-kbct="link_click" data-kblb="printer" data-kbgp="detail" data-kbsc="detail"
      >
        <i className="ic-npa ic-npa-icon-print" />
      </a>
      <p>พิมพ์</p>
    </div>
  );
};

const ShareBtn = (propertyDetail) => {
  return (
    <div>
      <button type="button" name="share" className="social-btn social-btn-show-dt" id="shared-btn" 
      >
        <i className="ic-npa ic-npa-icon-share" 
        data-kbct="open_popup" data-kblb="main_link" data-kbgp="social_share" data-kbsc="detail"
        />
      </button>
      <button
        type="button"
        name="share"
        className="social-btn social-btn-hide-dt"
        data-bs-toggle="offcanvas"
        data-bs-target="#shared-offcanvas"
        aria-controls="offcanvasBottom"
      >
        <i className="ic-npa ic-npa-icon-share" />
      </button>
      <p>แชร์</p>
      <div className="social-dropdown-menu">
        <div className="wrapper-input-link">
          <input
            type="text"
            defaultValue=""
            className="input-link"
            id="input-link"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="คัดลอกลิ้งค์แล้ว"
            data-bs-custom-class="custom-tooltip"
          />
          <div className="wrapper-icon">
            <i className="ic-npa ic-npa-icon-copylink copy-link ic-for-copy" />
            <i
              className="ic-npa ic-npa-icon-copiedlink copy-link ic-already-copy"
              style={{ display: "none" }}
            />
          </div>
        </div>
        <div className="wrapper-icon-share">
          <a
            href="javascript:void(0)"
            onClick={tweetShare}
            className="d-flex justify-content-center align-items-center fab fa-twitter"
            data-kbct="click" data-kblb="x" data-kbgp="social_share" data-kbsc="detail" 
          >
            <i className="ic-npa ic-npa-icon-twitter" />
          </a>
          <a
            href="javascript:void(0)"
            onClick={fbShare}
            className="d-flex justify-content-center align-items-center fab fa-facebook-f"
            data-kbct="click" data-kblb="facebook" data-kbgp="social_share" data-kbsc="detail" 
          >
            <i className="ic-npa ic-npa-icon-facebook" />
          </a>
          <a href="javascript:void(0)" onClick={lineMSG} className="d-flex justify-content-center align-items-center fab fa-line"
          data-kbct="click" data-kblb="line" data-kbgp="social_share" data-kbsc="detail">
            <i className="ic-npa ic-npa-icon-line" />
          </a>
          <a href="javascript:void(0)" onClick={mailShare} className="d-flex justify-content-center align-items-center"
          data-kbct="click" data-kblb="mail" data-kbgp="social_share" data-kbsc="detail">
            <i className="ic-npa ic-npa-icon-email" />
          </a>
        </div>
      </div>
    </div>
  );
};

const FavoriteToggleButton = ({ propId }) => {
  const propertyId = propId ? propId : "";
  const [isFavorite, setIsFavorite] = useState(false);

  const handleToggle = () => {
    if (isFavorite) {
      removeFromFavoriteProperty(propertyId);
    } else {
      addToFavoriteProperty(propertyId);
    }
    setIsFavorite(!isFavorite);
  };

  // Check if the property is already in the 'favoriteProperty' list
  const isPropertyInFavorites = () => {
    if (propertyId) {
      const favoriteProperty = getCookie("favoriteProperty") || "";
      const favoriteList = favoriteProperty.split(",");
      return favoriteList.includes(propertyId.toString());
    }
  };

  // Set the initial state based on whether the property is in the 'favoriteProperty' list
  useState(() => {
    setIsFavorite(isPropertyInFavorites());
  }, [propertyId]);

  return (
    <>
      <div className="box-favorite">
        <button
          type="button"
          name="like"
          className={classnames([{ active: isFavorite }, "social-btn favorite-btn"])}
          onClick={handleToggle}
          >
          <i
            data-kbct="click" data-kblb="favorite" data-kbgp="detail" data-kbsc="detail" data-kbid={propertyId} 
            className={classnames([
              { "ic-npa-icon-like-active": isFavorite },
              { "ic-npa-icon-like": !isFavorite },
              "ic-npa",
            ])}
          ></i>
        </button>
        <p>ถูกใจ</p>
        <div className="tooltip-favorite">
          <button type="button" className="close-tooltip" />
          <span>กรุณากดยอมรับ Cookie สำหรับ การเพิ่มทรัพย์ถูกใจ</span>
        </div>
      </div>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.TitlePageName === nextProps.TitlePageName;
}
